import React from 'react';
import { RouteProps } from 'react-router-dom';
import {
	componentPagesMenu,
	dashboardPagesMenu,
	gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
} from '../menu';

import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';
import PageLayoutHeader from '../pages/_layout/_headers/PageLayoutHeader';
import ComponentsHeader from '../pages/_layout/_headers/ComponentsHeader';
import FormHeader from '../pages/_layout/_headers/FormHeader';
import ChartsHeader from '../pages/_layout/_headers/ChartsHeader';
import ContentHeader from '../pages/_layout/_headers/ContentHeader';
import UtilitiesHeader from '../pages/_layout/_headers/UtilitiesHeader';
import IconHeader from '../pages/_layout/_headers/IconHeader';
import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';
import DocumentationHeader from '../pages/_layout/_headers/DocumentationHeader';

const headers: RouteProps[] = [
	// Page layouts without headers
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path, element: null },
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	
	// Auth pages without headers
	{ path: 'auth-pages/login', element: null },
	{ path: 'auth-pages/sign-up', element: null },
	{ path: 'auth-pages/404', element: null },
	{ path: 'view-article/:id', element: null },
	
	// Landing page - no header (self-contained page)
	{ path: '/', element: null },
	// Core application pages with dashboard header
	{ path: dashboardPagesMenu.analytics.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.manageUsers.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.manageArticles.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.createNewArticle.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.campaignManagement.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.postData.path, element: <DashboardHeader /> },
	{ path: '/admin/web-series', element: <DashboardHeader /> },
	{ path: '/admin/web-series/create', element: <DashboardHeader /> },
	{ path: '/admin/web-series/edit/:seriesId', element: <DashboardHeader /> },
	{ path: '/admin/web-series/articles', element: <DashboardHeader /> },
	{ path: '/admin/web-series/:seriesId/episodes', element: <DashboardHeader /> },
	{ path: '/admin/web-series/:seriesId/studio', element: <DashboardHeader /> },
	{ path: '/admin/web-series-sections', element: <DashboardHeader /> },
	{ path: '/admin/web-series-sections/:sectionId/series', element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.homeSectionManagement.path, element: <DashboardHeader /> },
	
	// Push Notifications
	{ path: dashboardPagesMenu.pushNotifications.path, element: <DashboardHeader /> },
	
	// Article Workflow pages
	{ path: dashboardPagesMenu.workflowManagement.subMenu.authorWorkflow.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.workflowManagement.subMenu.editorWorkflow.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.workflowManagement.subMenu.publisherWorkflow.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.workflowManagement.subMenu.adminWorkflowDashboard.path, element: <DashboardHeader /> },
	
	// Access Control pages
	{ path: dashboardPagesMenu.accessControlManagement.subMenu.permissionManagement.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.accessControlManagement.subMenu.rolePermissionMatrix.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.accessControlManagement.subMenu.userAccessControl.path, element: <DashboardHeader /> },
	{ path: dashboardPagesMenu.accessControlManagement.subMenu.auditLogs.path, element: <DashboardHeader /> },
	
	// Home Section Article Management
	{ path: '/admin/home-sections/:sectionId/articles', element: <DashboardHeader /> },

	// Article Language Variants
	{ path: '/admin/articles/:articleId/variants', element: <DashboardHeader /> },

	// State Configuration
	{ path: '/admin/state-configuration/workflow-config', element: <DashboardHeader /> },
	{ path: '/admin/state-configuration/user-state-roles', element: <DashboardHeader /> },

	// Workflow screens
	{ path: '/workflow/state-editor', element: <DashboardHeader /> },

	// Content Distribution
	{ path: '/admin/content-distribution', element: <DashboardHeader /> },
	{ path: '/admin/articles/:articleId/content', element: <DashboardHeader /> },

	// AI Content Tools
	{ path: 'admin/ai/journalist', element: <DashboardHeader /> },
	
	// User Details page
	{ path: 'user-details/:userId', element: <DashboardHeader /> },
	
	// Audio Settings pages
	{ path: 'admin/audio-settings/voices', element: <DashboardHeader /> },
	{ path: 'admin/audio-settings/bgm', element: <DashboardHeader /> },
	
	// State Coverage Dashboard
	{ path: 'admin/state-coverage', element: <DashboardHeader /> },

	// Article Report
	{ path: 'admin/article-report', element: <DashboardHeader /> },

	// Moderation
	{ path: 'moderation/comments', element: <DashboardHeader /> },
	{ path: 'moderation/reports', element: <DashboardHeader /> },

	// Reporter Platform pages
	{ path: 'admin/reporters', element: <DashboardHeader /> },
	{ path: 'admin/reporters/:reporterId', element: <DashboardHeader /> },
	{ path: 'admin/redemptions', element: <DashboardHeader /> },
	{ path: 'admin/coin-rules', element: <DashboardHeader /> },

	// News Intelligence pages
	{ path: 'admin/news-intelligence/digest', element: <DashboardHeader /> },
	{ path: 'admin/news-intelligence/sources', element: <DashboardHeader /> },
	{ path: 'admin/news-intelligence/sync-logs', element: <DashboardHeader /> },
	{ path: 'admin/news-intelligence/youtube/digest', element: <DashboardHeader /> },
	{ path: 'admin/news-intelligence/youtube/channels', element: <DashboardHeader /> },
	
	// Page layout types
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PageLayoutHeader />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PageLayoutHeader />,
	},
	{
		path: `${pageLayoutTypesPagesMenu.asideTypes.path}/*`,
		element: <PageLayoutHeader />,
	},
	
	// Component documentation pages
	{
		path: `${componentPagesMenu.components.path}/*`,
		element: <ComponentsHeader />,
	},
	{
		path: `${componentPagesMenu.forms.path}/*`,
		element: <FormHeader />,
	},
	{
		path: `${componentPagesMenu.charts.path}/*`,
		element: <ChartsHeader />,
	},
	{
		path: `${componentPagesMenu.content.path}/*`,
		element: <ContentHeader />,
	},
	{
		path: `${componentPagesMenu.utilities.path}/*`,
		element: <UtilitiesHeader />,
	},
	{
		path: `${componentPagesMenu.icons.path}/*`,
		element: <IconHeader />,
	},
	{
		path: `${gettingStartedPagesMenu.gettingStarted.path}/*`,
		element: <DocumentationHeader />,
	},
	{
		path: `${gettingStartedPagesMenu.routes.path}/*`,
		element: <DocumentationHeader />,
	},
	{
		path: `*`,
		element: <DefaultHeader />,
	},
];

export default headers;